/**
 * AiNotice — Bannière de transparence EU AI Act (Article 50).
 *
 * Obligation Art 50 : informer l'utilisateur qu'il interagit avec une IA / que le
 * contenu est généré par une IA. À placer sur les composants génératifs/conversationnels :
 *   - ChatPage (assistant conversationnel)
 *   - ClauseBenefPage (génération de clauses)
 *
 * Texte aligné sur config/ai_act_register.yaml → transparency_art50.notice (backend).
 * Volontairement STATIQUE : l'obligation est fixe pour ces écrans (pas besoin d'un hook/
 * appel API gaté). Si on veut piloter dynamiquement, voir GET /api/v1/admin/ai-act/register.
 *
 * Ticket 8.0-04 · ADR (transparence) · DEMO-01 (3 personas).
 */
import type { ReactElement } from 'react';

export interface AiNoticeProps {
  /** Texte override éventuel (défaut = notice Art 50 standard). */
  text?: string;
  /** Variante d'affichage : 'banner' (bandeau) ou 'inline' (sous un contenu généré). */
  variant?: 'banner' | 'inline';
}

const DEFAULT_NOTICE =
  'Contenu généré par une IA — à vérifier par un humain. (Transparence EU AI Act, art. 50)';

export default function AiNotice({ text = DEFAULT_NOTICE, variant = 'banner' }: AiNoticeProps): ReactElement {
  const base = 'flex items-center gap-2 text-xs text-slate-600';
  const style =
    variant === 'banner'
      ? `${base} rounded-md border border-slate-200 bg-slate-50 px-3 py-2`
      : `${base} mt-1 italic`;
  return (
    <div className={style} role="note" aria-label="Avertissement IA (AI Act art. 50)" data-testid="ai-notice">
      <span aria-hidden="true">🤖</span>
      <span>{text}</span>
    </div>
  );
}
